export default () => ({
  totalNotCorrected                     : null,
  totalNewMessages                      : null,
  totalNotCorrectedDetailsModal         : null,
  totalNewMessagesDetailsModal          : null,
  totalSatisfactoryProgress             : null,
  totalSatisfactoryProgressDetailsModal : null
});
